
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AuthForm } from '@/components/auth/AuthForm';
import { useAuthForm } from '@/hooks/useAuthForm';

export default function Auth() {
  const [searchParams] = useSearchParams();
  const [isSignUp, setIsSignUp] = useState(false);
  const {
    formData,
    isLoading,
    validationError,
    handleFormChange,
    handleSubmit,
    handleForgotPassword,
  } = useAuthForm();

  useEffect(() => {
    // Check if we should start in signup mode
    const signupParam = searchParams.get('signup');
    if (signupParam === 'true') {
      setIsSignUp(true);
    }
  }, [searchParams]);

  const toggleMode = () => {
    setIsSignUp(!isSignUp);
  };

  const onSubmit = (e: React.FormEvent) => {
    handleSubmit(e, isSignUp);
  };

  return (
    <div className="container mx-auto py-8">
      <div className="max-w-md mx-auto">
        <Card>
          <CardHeader>
            <CardTitle>{isSignUp ? 'Create Account' : 'Sign In'}</CardTitle>
          </CardHeader>
          <CardContent>
            <AuthForm
              isSignUp={isSignUp}
              isLoading={isLoading}
              validationError={validationError}
              formData={formData}
              onSubmit={onSubmit}
              onChange={handleFormChange}
              onToggleMode={toggleMode}
              onForgotPassword={handleForgotPassword}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
